<template>
    <transition name="fade-zoom">
        <bubble :count="chatCount"></bubble>
    </transition>
</template>

<script>
export default
{
    name: 'ChantBubble',

    props: ['getter', 'limit', 'count'],

    computed:
    {
        chatCount()
        {
            let count = (this.getter) ? this.$store.getters[this.getter] : this.count;

            if (count === 0) return false;
            return (count > this.limit)? `+${this.limit}` : count
        }
    }
}
</script>



// WEBPACK FOOTER //
// ChatBubble.vue?0c37d8d8